import React, { useState, useEffect } from 'react'
import {
    ListBox
} from '@progress/kendo-react-listbox';
// * Helpers
import Notifications, { ERROR_NOTIFICATION, SUCCESS_NOTIFICATION } from '../../helpers/notifications';
import { useTranslation } from 'react-i18next';
import API from "../../services/api";
import { BEN_UNIT_HOUSEHOLDS } from '../PopGroups/costants';
// Reac number format
import NumberFormat from 'react-number-format';

/*List of icons used in this component*/
/**Important: to see the full icons list visit: https://react-icons.github.io/react-icons */
import { ImArrowRight, ImArrowLeft } from 'react-icons/im'
import validator from 'validator';
import { VIEW } from '../../assets/Constants/actionsTypes';

// Used to show the selected item inside the box
const SELECTED_FIELD = "selected";

const Step4 = (props) => {
    // * we call the hook to make translations
    const { t } = useTranslation('common');
    // * Selected benefit id state
    const [selectedBenefitId, setSelectedBenefitId] = useState(0);
    // * Input state
    const [ibam, setIBAM] = useState('');
    const [iantrans, setIANTRANS] = useState('');
    const [iadm, setIADM] = useState('');
    const [ithr, setITHR] = useState('');
    const [ichh, setICHH] = useState('');
    const [icpmale, setICPMale] = useState('');
    const [icpfemale, setICPFemale] = useState('');
    const [ihhavs, setIhhavs] = useState('')
    const [beneficiaryUnit, setBeneficiaryUnit] = useState('')
    const [isHouseHold, setIsHouseHold] = useState(false)
    // * ListBox components state
    const [state, setState] = React.useState({
        benefitsList: []
    });

    // * we use useEffect to call the function that returns the step2 data
    useEffect(() => {
        if (props.activeStep === 4) {
            // Setting the states as shown below helps to avoid displaying incorrect data when passing 
            // from one step to the next (or previous).
            setIBAM('');
            setIANTRANS('');
            setIADM('');
            setITHR('');
            setICHH('');
            setICPMale('');
            setICPFemale('');
            setIhhavs('');
            setBeneficiaryUnit('');
            setIsHouseHold(false);
            setSelectedBenefitId(0);
            // Gets the benefits list
            getStep4_Benefits();
        }
    }, [props.activeStep]);// eslint-disable-line react-hooks/exhaustive-deps

    // * Gets the benefits list
    const getStep4_Benefits = async () => {
        try {
            // Gets the data from each of the lists, they are all fetched at once 
            // to avoid losing data for different setSate in different functions.
            const responseBenefits = await API.get(`/model/step4BenefitsList?modelId=${props.modelData.modelid}`);
            // if error in request
            if (responseBenefits.data.code !== 100) {
                Notifications.notify(responseBenefits.data.msg, ERROR_NOTIFICATION);
                return;
            } else {

                const benefitsListBD = responseBenefits.data.data;

                const benefitsListFirstSelected = benefitsListBD.map((item, i) => {
                    if (0 === i) {
                        item[SELECTED_FIELD] = true;
                    } else {
                        item[SELECTED_FIELD] = false;
                    }
                    return item;
                });

                setState({
                    ...state,
                    benefitsList: benefitsListFirstSelected
                });

                // saves the benefit id as state
                setSelectedBenefitId(benefitsListBD[0].benefitId);
                // Fills the inputs with the selected benefit information
                fillInputs(benefitsListBD[0].benefitId);

                // Searching Household benefits. This lets us know if the system should display the Average Size field.
                // If at least one benefit in the list is Household, the field should be displayed
                const firstHousehold = benefitsListBD.find((item) => item.beneficiaryUnit === BEN_UNIT_HOUSEHOLDS)
                if (firstHousehold) {
                    setIsHouseHold(true);
                }
            }
        } catch (e) {
            Notifications.notify(String(e), ERROR_NOTIFICATION);
            console.log(e)
        }
    }

    // * This function is called when the PREVIOUS arrow is clicked.
    // * Saves the data of the step 4
    // * If the saves was ok, the step 3 is called
    const onPreviousClick = async () => {
        // Only saves when is in edit mode
        if (props.isEditMode) {
            // * When calling an async/await function that returns a boolean, you must wait for its response, 
            // * since it is a promise and will NOT return the desired bool.
            const returnValue = await saveStep4Data();
            if (returnValue) {
                props.changeStep(3);
            }
        } else {
            props.changeStep(3);
        }
    }

    // * This function is called when the NEXT arrow is clicked.
    // * Saves the data of the step 4
    // * If the saves was ok, the step 5 is called
    const onNextClick = async () => {
        // Only saves when is in edit mode
        if (props.isEditMode) {
            // * When calling an async/await function that returns a boolean, you must wait for its response, 
            // * since it is a promise and will NOT return the desired bool.
            const returnValue = await saveStep4Data();
            if (returnValue) {
                props.changeStep(5);
            }
        } else {
            props.changeStep(5);
        }
    }

    // * Calls the API to save the data of the selected benefit
    // * If it returns false, it means that some input is wrong.
    // * If it returns true, it means that everything is OK.
    const saveStep4Data = async () => {
        // * Validations
        // --- selected benefit validation
        // selectedBenefitId = 0 means that no benefit was selected, so when going to step 5 or 3 nothing is saved.
        if (selectedBenefitId === 0) {
            return true;
        }
        // --- empty validations
        if (validator.isEmpty(ibam.toString()) || validator.isEmpty(iantrans.toString()) ||
            validator.isEmpty(iadm.toString()) || validator.isEmpty(ithr.toString())) {
            Notifications.notify(t('model.values_required'), ERROR_NOTIFICATION);
            return false;
        }
        // if household validations
        if (beneficiaryUnit === BEN_UNIT_HOUSEHOLDS) {
            if (validator.isEmpty(ichh.toString())) {
                Notifications.notify(t('model.values_required'), ERROR_NOTIFICATION);
                return false;
            }
            if (!validator.isFloat(ichh.toString())) {
                Notifications.notify(t('model.ichh_number'), ERROR_NOTIFICATION);
                return false;
            }
        } else {
            if (validator.isEmpty(icpfemale.toString()) || validator.isEmpty(icpmale.toString())) {
                Notifications.notify(t('model.values_required'), ERROR_NOTIFICATION);
                return false;
            }
            if (!validator.isFloat(icpfemale.toString())) {
                Notifications.notify(t('model.icpfemale_number'), ERROR_NOTIFICATION);
                return false;
            }
            if (!validator.isFloat(icpmale.toString())) {
                Notifications.notify(t('model.icpmale_number'), ERROR_NOTIFICATION);
                return false;
            }
        }
        // --- number validations
        if (!validator.isFloat(ibam.toString())) {
            Notifications.notify(t('model.ibam_number'), ERROR_NOTIFICATION);
            return false;
        }
        if (!validator.isFloat(iantrans.toString())) {
            Notifications.notify(t('model.iantrans_number'), ERROR_NOTIFICATION);
            return false;
        }
        if (!validator.isFloat(iadm.toString())) {
            Notifications.notify(t('model.iadm_number'), ERROR_NOTIFICATION);
            return false;
        }
        if (!validator.isFloat(ithr.toString())) {
            Notifications.notify(t('model.ithr_number'), ERROR_NOTIFICATION);
            return false;
        }
        if (validator.isEmpty(ihhavs.toString())) {
            Notifications.notify(t('model.values_required'), ERROR_NOTIFICATION);
            return false;
        }
        if (!validator.isFloat(ihhavs.toString())) {
            Notifications.notify(t('model.ihhavs_number'), ERROR_NOTIFICATION);
            return false;
        }
        if (parseFloat(ihhavs.toString()) < 1) {
            Notifications.notify(t('model.ihhavs_exception'), ERROR_NOTIFICATION);
            return false;
        }

        // data to be sent
        let data = {
            modelid: props.modelData.modelid,
            benefitId: selectedBenefitId,
            ibam: ibam,
            iantrans: iantrans,
            iadm: iadm,
            ithr_abam: ithr,
            itexp: 0,//itexp was remove like input, but no deleted from bd
            ichh: beneficiaryUnit === BEN_UNIT_HOUSEHOLDS ? ichh : 0,
            icpmale: beneficiaryUnit === BEN_UNIT_HOUSEHOLDS ? 0 : icpmale,
            icpfemale: beneficiaryUnit === BEN_UNIT_HOUSEHOLDS ? 0 : icpfemale,
            ihhavs: ihhavs
        }

        // * call the api to do the upsert
        const res = await API.post('/model/step4InsertData', data);

        // * if errors exist, it is displayed as a notification
        if (res.data.code !== 100) {
            Notifications.notify(t(`model.${res.data.code}`), ERROR_NOTIFICATION);
            return false;
        }

        return true;
    }

    // Triggered when an user clicks an element inside the box of Benefits
    const modelBenfitsClick = async (event, data) => {
        // Saves the previous benefit data (like an onChange event)
        if (selectedBenefitId !== 0) {
            // selectedBenefit == 0 means that there is no previous benefit
            // Only saves when is in edit mode
            if (props.isEditMode) {
                // Tries to save the previous benefit
                const returnValue = await saveStep4Data();
                // If was successfully saved a message is displayed
                if (returnValue) {
                    Notifications.notify(t(`model.benefit_step4_6_message`), SUCCESS_NOTIFICATION);
                }
            }
        }
        // Set the state and select the option
        setState({
            ...state,
            [data]: state[data].map((item) => {
                if (item.name === event.dataItem.name) {
                    item[SELECTED_FIELD] = !item[SELECTED_FIELD];
                } else {
                    item[SELECTED_FIELD] = false;
                }
                return item;
            })
        });
        // saves the benefit id as state
        setSelectedBenefitId(event.dataItem.benefitId);
        // Fills the inputs with the selected benefit information
        fillInputs(event.dataItem.benefitId);
    }

    // Gets the information of the selected benefit and set the state of each input
    const fillInputs = async (benefitId) => {
        try {
            const responseBenefitsData = await API.get(`/model/step4BenefitData?modelId=${props.modelData.modelid}&benefitId=${benefitId}`);
            // Message
            if (responseBenefitsData.data.code !== 100) {
                Notifications.notify(responseBenefitsData.data.msg, ERROR_NOTIFICATION);
                return;
            } else {
                setIBAM(responseBenefitsData.data.data.ibam);
                setIADM(responseBenefitsData.data.data.iadm);
                setIANTRANS(responseBenefitsData.data.data.iantrans);
                setITHR(responseBenefitsData.data.data.ithR_ABAM);
                setICHH(responseBenefitsData.data.data.ichh);
                setICPMale(responseBenefitsData.data.data.icpMale);
                setICPFemale(responseBenefitsData.data.data.icpFemale);
                setBeneficiaryUnit(responseBenefitsData.data.data.beneficiaryUnit);
                setIhhavs(responseBenefitsData.data.data.ihhavs);
            }
        } catch (e) {
            Notifications.notify(String(e), ERROR_NOTIFICATION);
            console.log(e);
        }
    }

    return (
        <div className="col-md-12">
            <div className="row">
                <h6>{t('model.step4_desc')}</h6>
            </div>
            <div className="row row_attrs container_steps">
                <div className="col-sm-12">
                    {/**Form step4*/}
                    <div className="form-row">
                        <div className="form-group col-md-3">
                            <label className="ilo_lbl_general">{t('wizard.benefitDetails.benefitListTitle')}</label>
                            <ListBox
                                style={{
                                    height: 260,
                                    width: "100%",
                                }}
                                data={state.benefitsList}
                                textField="name"
                                selectedField={SELECTED_FIELD}
                                onItemClick={(e) => modelBenfitsClick(e, "benefitsList")}
                            />
                        </div>
                        <div className="form-group col-md-1">
                        </div>
                        <div className="form-group col-md-8">
                            <div className="form-row">
                                <div className="form-group col-md-6">
                                    <label className="required ilo_lbl_general">{t('wizard.benefitDetails.ibam')}</label>
                                    <NumberFormat
                                        className="form-control ilo-input ilo-modal-input inputs_right inputs_width_special"
                                        thousandsGroupStyle="thousand"
                                        value={ibam}
                                        decimalSeparator="."
                                        displayType="input"
                                        type="text"
                                        thousandSeparator={true}
                                        allowNegative={true}
                                        disabled={!props.isEditMode}
                                        onValueChange={(values) => {
                                            setIBAM(values.value);
                                        }}
                                    />
                                </div>
                                <div className="form-group col-md-6">
                                    <label className="required ilo_lbl_general">{t('wizard.benefitDetails.iantrans')}</label>
                                    <NumberFormat
                                        className="form-control ilo-input ilo-modal-input inputs_right inputs_width_special"
                                        thousandsGroupStyle="thousand"
                                        value={iantrans}
                                        decimalSeparator="."
                                        displayType="input"
                                        type="text"
                                        thousandSeparator={true}
                                        allowNegative={true}
                                        disabled={!props.isEditMode}
                                        onValueChange={(values) => {
                                            setIANTRANS(values.value);
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-group col-md-6">
                                    <label className="required ilo_lbl_general">{t('wizard.benefitDetails.iadm')}</label>
                                    <NumberFormat
                                        className="form-control ilo-input ilo-modal-input inputs_right inputs_width_special"
                                        thousandsGroupStyle="thousand"
                                        value={iadm}
                                        decimalSeparator="."
                                        displayType="input"
                                        type="text"
                                        thousandSeparator={true}
                                        allowNegative={true}
                                        disabled={!props.isEditMode}
                                        onValueChange={(values) => {
                                            setIADM(values.value);
                                        }}
                                    />
                                </div>
                                <div className="form-group col-md-6">
                                    <label className="required ilo_lbl_general">{t('wizard.benefitDetails.ithr_abam')}</label>
                                    <NumberFormat
                                        className="form-control ilo-input ilo-modal-input inputs_right inputs_width_special"
                                        thousandsGroupStyle="thousand"
                                        value={ithr}
                                        decimalSeparator="."
                                        displayType="input"
                                        type="text"
                                        thousandSeparator={true}
                                        allowNegative={true}
                                        disabled={!props.isEditMode}
                                        onValueChange={(values) => {
                                            setITHR(values.value);
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="form-row">
                                {beneficiaryUnit === '' ?
                                    <></>
                                    :
                                    beneficiaryUnit === BEN_UNIT_HOUSEHOLDS ?
                                        <div className="form-group col-md-6">
                                            <label className="required ilo_lbl_general">{t('wizard.benefitDetails.ichh')}</label>
                                            <NumberFormat
                                                className="form-control ilo-input ilo-modal-input inputs_right inputs_width_special"
                                                thousandsGroupStyle="thousand"
                                                value={ichh}
                                                decimalSeparator="."
                                                displayType="input"
                                                type="text"
                                                thousandSeparator={true}
                                                allowNegative={true}
                                                disabled={!props.isEditMode}
                                                onValueChange={(values) => {
                                                    setICHH(values.value);
                                                }}
                                            />
                                        </div>
                                        :
                                        <>
                                            <div className="form-group col-md-6">
                                                <label className="required ilo_lbl_general">{t('wizard.benefitDetails.icpfemale')}</label>
                                                <NumberFormat
                                                    className="form-control ilo-input ilo-modal-input inputs_right inputs_width_special"
                                                    thousandsGroupStyle="thousand"
                                                    value={icpfemale}
                                                    decimalSeparator="."
                                                    displayType="input"
                                                    type="text"
                                                    thousandSeparator={true}
                                                    allowNegative={true}
                                                    disabled={!props.isEditMode}
                                                    onValueChange={(values) => {
                                                        setICPFemale(values.value);
                                                    }}
                                                />
                                            </div>
                                            <div className="form-group col-md-6">
                                                <label className="required ilo_lbl_general">{t('wizard.benefitDetails.icpmale')}</label>
                                                <NumberFormat
                                                    className="form-control ilo-input ilo-modal-input inputs_right inputs_width_special"
                                                    thousandsGroupStyle="thousand"
                                                    value={icpmale}
                                                    decimalSeparator="."
                                                    displayType="input"
                                                    type="text"
                                                    thousandSeparator={true}
                                                    allowNegative={true}
                                                    disabled={!props.isEditMode}
                                                    onValueChange={(values) => {
                                                        setICPMale(values.value);
                                                    }}
                                                />
                                            </div>
                                        </>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-group col-md-3">
                            <label className="required ilo_lbl_general">{t('wizard.benefitDetails.average_hh')}</label>
                            <NumberFormat
                                className="form-control ilo-input ilo-modal-input inputs_right inputs_width_special"
                                thousandsGroupStyle="thousand"
                                value={ihhavs}
                                decimalSeparator="."
                                displayType="input"
                                type="text"
                                thousandSeparator={true}
                                allowNegative={true}
                                disabled={!props.isEditMode}
                                onValueChange={(values) => {
                                    setIhhavs(values.value);
                                }}
                            />
                            {/**<small>{t('wizard.benefitDetails.average_hh_des')}</small>*/}
                        </div>
                    </div>
                </div>
            </div>
            <div className="row arrows_position">
                <div className="col-sm-12">
                    <button className="btn_style" type="button" onClick={() => { onPreviousClick(); }} ><ImArrowLeft /></button>
                    {props.isActionView === VIEW ? null : !props.isEditMode ? (
                        <button
                            onClick={() => { props.editSteps(); }}
                            className="btn btn-primary ilo-btn"
                            style={{ marginBottom: "10px", marginRight: "3px" }}
                        >
                            {t('model.step7_edit_btn')}
                        </button>
                    ) : null
                    }
                    <button className="btn_style" type="button" onClick={() => { onNextClick(); }} ><ImArrowRight /></button>
                </div>
            </div>
        </div>
    );
}

export default Step4